import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { ShipmentPlannerProfileReportService } from './shipment-planner-profile-report.service';
import {
  ShipmentPlannerProfileReportInitialState,
  ShipmentPlannerProfileReportLoad,
} from './shipment-planner-profile-report.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { ShipmentProfileReport } from '../models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentPlannerProfileReportStateModel {
  report: ShipmentProfileReport;
  loaded: boolean;
}

const initialState: ShipmentPlannerProfileReportStateModel = {
  report: new ShipmentProfileReport(),
  loaded: false,
};

@State<ShipmentPlannerProfileReportStateModel>({
  name: 'shipmentPlannerProfileReport',
  defaults: initialState,
})
@Injectable()
export class ShipmentPlannerProfileReportState {
  constructor(
    private shipmentPlannerProfileReportService: ShipmentPlannerProfileReportService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getReport(state: ShipmentPlannerProfileReportStateModel): ShipmentProfileReport {
    return state.report;
  }

  @Selector()
  static getState(state: ShipmentPlannerProfileReportStateModel): ShipmentPlannerProfileReportStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentPlannerProfileReportStateModel): boolean {
    return state.loaded;
  }

  @Action(ShipmentPlannerProfileReportLoad)
  getReport(
    ctx: StateContext<ShipmentPlannerProfileReportStateModel>,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentPlannerProfileReportService.getReport().pipe(
      map((report: ShipmentProfileReport) => {
        ctx.patchState({
          report: new ShipmentProfileReport(report),
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentPlannerProfileReportInitialState)
  setInitialState(ctx: StateContext<ShipmentPlannerProfileReportStateModel>): void {
    ctx.setState(initialState);
  }
}
